module.exports = __webpack_public_path__ + "assets/Terrorism.75ce087c.svg";